import { useDispatch } from "react-redux";

import {
  requestCaseSearch,
  updatePageNumber,
  updatePageSize,
  updatePageFilter,
} from "../Store/mutations";

const useExportsPageControls = () => {
  const dispatch = useDispatch();

  const handleExportsPageChange = (pageName, page) => {
    if (page.length > 0 && page <= 0) {
      page = 1;
    }

    if (page.length > 0) {
      page = Math.ceil(page);
    }

    dispatch(updatePageNumber(pageName, page));
    if (pageName === "case") {
      dispatch(requestCaseSearch());
    }
  };

  const handleExportsPageFilterChange = (pageName, filter) => {
    dispatch(updatePageFilter(pageName, filter));
  };

  const handleExportsPageSizeChange = (pageName, size) => {
    dispatch(updatePageSize(pageName, size));
    if (pageName === "case") {
      dispatch(requestCaseSearch());
    }
  };

  return {
    handleExportsPageChange,
    handleExportsPageFilterChange,
    handleExportsPageSizeChange,
  };
};

export default useExportsPageControls;
